import Head from 'next/head';
import { Thing, WithContext } from 'schema-dts';

export const JsonLdBase = <T extends Thing>({ data }: { data?: T | null }) =>
  data && typeof data === 'object' ? (
    <Head>
      <script
        type='application/ld+json'
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            ...data,
          } as WithContext<T>),
        }}
      />
    </Head>
  ) : null;
